import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import {
  Modal,
  Box,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";

import { toast } from "react-toastify";
import { setGroups } from "../redux/slices/groupsSlice";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "95%", sm: "80%", md: "40%" },

  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,

  maxHeight: "80vh",
  overflowY: "auto",
  borderRadius: { xs: "9px", md: "15px" },
};

const GroupList = ({ selectedOption }) => {
  const [open, setOpen] = useState(false);
  const groups = useSelector((state) => state?.groups?.groups);
  const meetingSpaces = useSelector(
    (state) => state?.allmeetingspaces?.allmeetingspaces
  );
  const [groupName, setGroupName] = useState("");
  const dispatch = useDispatch();
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const headers = useSelector((state) => state.header);
  const emmsheaders = useSelector((state) => state.emmsheader);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [success, setSuccessMessage] = useState();
  const api = localStorage.getItem("api");
  const curremms = useSelector((state) => state.curremms);
  const oldGroupsData = useSelector((state) => state?.groups?.groups);

  const mergedData = groups?.map((group) => {
    const spaces = meetingSpaces?.filter((space) =>
      space.customProperties?.groups?.includes(group.id)
    );
    return { ...group, spaces };
  });
  const handleSubmit = (event) => {
    event.preventDefault();

    if (!groupName?.trim()) {
      toast.error("Name is required.", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    }

    setIsSubmitting(true);
    const json2 = {
      name: groupName,
    };

    const requestBody = {
      path: "groups",
      query: {},
      emmsId: `${selectedOption}`,
      body: { ...json2 },
      requestType: "POST",
      headers: emmsheaders?.emmsheaders?.headers,
    };

    axios
      .post(api + `/emms/piggyback`, requestBody, headers)
      .then((response) => {
        setIsSubmitting(false);
        setErrorModalOpen(true);
        const combinedData = [response?.data, ...oldGroupsData];

        dispatch(setGroups(combinedData));
        setErrorMessage(`Group  created successfully`);
        setGroupName("");
        setSuccessMessage(true);
      })
      .catch((error) => {
        setErrorModalOpen(true);
        setGroupName("");
        setErrorMessage(`Error creating group: ${error?.response?.data}`);
        setSuccessMessage(false);
      });
  };
  return (
    <div>
      <Button
        sx={{ textTransform: "none" }}
        variant="contained"
        onClick={handleOpen}
      >
        Show Groups
      </Button>
      <Modal open={open} onClose={handleClose}>
        <Box sx={modalStyle}>
          <Typography
            id="group-meeting-modal-title"
            variant="h5"
            component="h2"
            gutterBottom
          >
            Meeting Room Groups
          </Typography>
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold" }}>Group Name</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>
                    Meeting Space Name
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {mergedData?.map((group) =>
                  group?.spaces?.length > 0 ? (
                    group?.spaces?.map((space) => (
                      <TableRow key={space.id}>
                        {space.id === group.spaces[0].id && (
                          <TableCell rowSpan={group?.spaces?.length}>
                            {group.name}
                          </TableCell>
                        )}
                        <TableCell>{space.name}</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow key={group.id}>
                      <TableCell>{group.name}</TableCell>
                      <TableCell>
                        No meeting spaces available for this group.
                      </TableCell>
                    </TableRow>
                  )
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <Box display="flex" alignItems="center" mt={4} gap={2}>
            <TextField
              size="small"
              label="New Group Name"
              variant="outlined"
              value={groupName}
              onChange={(e) => setGroupName(e.target.value)}
              fullWidth
            />

            <Box
              sx={{
                display: "flex",
                gap: 2
              }}
            >
              <Button
                style={{ textTransform: "none" }}
                variant="outlined"
                color="error"
                onClick={() => setOpen(false)}
                disabled={isSubmitting}
              >
                Close
              </Button>
              <Button variant="contained" onClick={handleSubmit}>
                Create
              </Button>

            </Box>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default GroupList;
